import {
  faCheckCircle,
  faExclamationCircle,
  faInfoCircle,
  faExclamationTriangle,
} from '@fortawesome/pro-solid-svg-icons';
import { OL_COLOUR_MELON, OL_COLOUR_TOMAHTO } from '../Style/colours';
import { AlertMessageThemes } from './types';

export const ALERT_MESSAGE_STYLES: AlertMessageThemes = {
  info: {
    background: '#F0F7FA',
    iconColor: '#094967',
    borderColor: '#2A9FED',
  },
  success: {
    background: 'rgba(0, 135, 77, 0.1)', // OL_COLOUR_MELON 10%
    iconColor: OL_COLOUR_MELON,
    borderColor: OL_COLOUR_MELON,
  },
  warning: {
    background: 'rgba(255, 153, 0, 0.1)', // #FF9900 10%
    iconColor: '#FF9900',
    borderColor: '#FF9900',
  },
  error: {
    background: 'rgba(220, 42, 42, 0.1)', // OL_COLOUR_TOMAHTO 10%
    iconColor: OL_COLOUR_TOMAHTO,
    borderColor: OL_COLOUR_TOMAHTO,
  },
};

export const ALERT_MESSAGE_ICONS = {
  info: faInfoCircle,
  success: faCheckCircle,
  warning: faExclamationTriangle,
  error: faExclamationCircle,
};
